import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import Layout from "./components/Layout/Layout";
import Dashboard from "./pages/Dashboard";
import Properties from "./pages/Properties";
import Tenants from "./pages/Tenants";
import Payments from "./pages/Payments";
import { Toaster } from "./components/ui/toaster";
import Maintenance from "./pages/Maintenance";
import TenantMaintenance from "./pages/TenantMaintenance";
import TenantPayment from "./pages/TenantPayment";
import TenantHistory from "./pages/TenantHistory";
import TenantHub from "./pages/TenantHub";
import TenantProfile from "./pages/TenantProfile";
import TenantDocuments from "./pages/TenantDocuments";
import TenantAutopay from "./pages/TenantAutopay";
import Leases from "./pages/Leases";
import Reports from "./pages/Reports";
import Documents from "./pages/Documents";
import Settings from "./pages/Settings";
import ContractorEstimateSubmission from "./pages/ContractorEstimateSubmission";
import LandlordLogin from "./pages/LandlordLogin";
import SimpleLogin from "./pages/SimpleLogin";
import LandingPage from "./pages/LandingPage";
import ResetPassword from "./pages/ResetPassword";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Landing Page */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Owner/Investor Portal Login */}
            <Route path="/owner" element={<LandlordLogin />} />
            
            {/* Admin Portal Login */}
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* SECURED Admin Dashboard - Requires authentication AND admin privileges */}
            <Route path="/admin" element={
              <AdminProtectedRoute>
                <Admin />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/dashboard" element={
              <AdminProtectedRoute>
                <Admin />
              </AdminProtectedRoute>
            } />
            
            {/* Password Reset */}
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Owner/Investor Portal - Dashboard (Protected Routes) */}
            <Route path="/owner/dashboard" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Dashboard /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/owner/properties" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Properties /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/owner/tenants" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Tenants /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/owner/payments" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Payments /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/owner/leases" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Leases /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/owner/maintenance" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Maintenance /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/owner/reports" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Reports /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/owner/documents" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Documents /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/owner/settings" element={
              <ProtectedRoute>
                <Layout userRole="landlord"><Settings /></Layout>
              </ProtectedRoute>
            } />

            {/* Contractor Estimate Submission (No Auth Required) */}
            <Route path="/contractor/estimate/:requestId" element={<ContractorEstimateSubmission />} />
            
            {/* Legacy Routes - Redirect to new structure */}
            <Route path="/login" element={<LandlordLogin />} />
            <Route path="/properties" element={<ProtectedRoute><Layout userRole="landlord"><Properties /></Layout></ProtectedRoute>} />
            <Route path="/tenants" element={<ProtectedRoute><Layout userRole="landlord"><Tenants /></Layout></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute><Layout userRole="landlord"><Payments /></Layout></ProtectedRoute>} />
            <Route path="/leases" element={<ProtectedRoute><Layout userRole="landlord"><Leases /></Layout></ProtectedRoute>} />
            <Route path="/maintenance" element={<ProtectedRoute><Layout userRole="landlord"><Maintenance /></Layout></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Layout userRole="landlord"><Reports /></Layout></ProtectedRoute>} />
            <Route path="/documents" element={<ProtectedRoute><Layout userRole="landlord"><Documents /></Layout></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Layout userRole="landlord"><Settings /></Layout></ProtectedRoute>} />
            
            {/* Test Route */}
            <Route path="/test-login" element={<SimpleLogin />} />
            
            {/* Tenant (Org-scoped) Routes (No Auth Required) */}
            <Route path="/o/:orgId/tenant" element={<Layout userRole="tenant"><TenantHub /></Layout>} />
            <Route path="/o/:orgId/tenant/payment" element={<Layout userRole="tenant"><TenantPayment /></Layout>} />
            <Route path="/o/:orgId/tenant/autopay" element={<Layout userRole="tenant"><TenantAutopay /></Layout>} />
            <Route path="/o/:orgId/tenant/maintenance" element={<Layout userRole="tenant"><TenantMaintenance /></Layout>} />
            <Route path="/o/:orgId/tenant/history" element={<Layout userRole="tenant"><TenantHistory /></Layout>} />
            <Route path="/o/:orgId/tenant/profile" element={<Layout userRole="tenant"><TenantProfile /></Layout>} />
            <Route path="/o/:orgId/tenant/documents" element={<Layout userRole="tenant"><TenantDocuments /></Layout>} />

            {/* Legacy Tenant Routes (non-org) - keep for now (No Auth Required) */}
            <Route path="/tenant" element={<Layout userRole="tenant"><TenantHub /></Layout>} />
            <Route path="/tenant/payments" element={<Layout userRole="tenant"><TenantPayment /></Layout>} />
            <Route path="/tenant/autopay" element={<Layout userRole="tenant"><TenantAutopay /></Layout>} />
            <Route path="/tenant/maintenance" element={<Layout userRole="tenant"><TenantMaintenance /></Layout>} />
            <Route path="/tenant/profile" element={<Layout userRole="tenant"><TenantProfile /></Layout>} />
            <Route path="/tenant/documents" element={<Layout userRole="tenant"><TenantDocuments /></Layout>} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </AuthProvider>
  );
}

export default App;
